<template>
  <section>
    <v-row>
      <v-col cols="12" sm="12" md="12">
        <v-card class="mb-6 ml-6 mr-2 mt-4">
          <v-form ref="form" lazy-validation>
            <v-card-title>Paramètres Généraux</v-card-title>
            <v-card-text class="mt-4">
              <v-row>
                <v-col cols="12" sm="12" md="6">
                  <v-switch
                    v-model="generalSettings.duaaOption"
                    label="Activer Duaa Option"
                    inset
                  ></v-switch>
                </v-col>
                <v-col cols="12" sm="12" md="6">
                  <vue-upload-multiple-image
                    style="margin-left: 160px"
                    v-model="images"
                    :data-images="images"
                    name="images"
                    accept="image/*	"
                    drag-text="Veuillez ajoutez une images svp!"
                    browse-text="Browse image"
                    primary-text="Primary image"
                    mark-is-primary-text="Set default image"
                    :min-image="1"
                    :multiple="false"
                    :showEdit="false"
                    popup-text="Description default image"
                    drop-text="Drag and drop"
                    @upload-success="uploadImageSuccess"
                    @before-remove="beforeRemove"
                  >
                  </vue-upload-multiple-image>
                  <v-progress-linear
                    v-if="showlowding && uploadPercentage < 100"
                    style="max-width: 190px; margin-left: 160px"
                    color="primary"
                    indeterminate
                    rounded
                    height="15"
                    ><strong
                      >{{ Math.ceil(uploadPercentage) }}%</strong
                    ></v-progress-linear
                  >
                </v-col>
                <v-col cols="12" sm="12" md="12">
                  <v-text-field
                    label="Paypal secret key"
                    placeholder="Paypal secret key"
                    v-model="generalSettings.paypalSecretKey"
                    outlined
                    required
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="12" md="12">
                  <v-text-field
                    label="Paypal public key"
                    placeholder="Paypal public key"
                    v-model="generalSettings.paypalPublicKey"
                    outlined
                    required
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="12" md="12">
                  <v-text-field
                    label="Stripe secret key"
                    placeholder="Stripe secret key"
                    v-model="generalSettings.stripeSecretKey"
                    outlined
                    required
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="12" md="12">
                  <v-text-field
                    label="Stripe public key"
                    placeholder="Stripe public key"
                    v-model="generalSettings.stripePublicKey"
                    outlined
                    required
                  ></v-text-field>
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="12" sm="12" md="12">
                  <div class="d-flex flex-row-reverse">
                    <v-btn
                      class="info"
                      :disabled="
                        generalSettings.stripePublicKey == '' ||
                        generalSettings.stripeSecretKey == '' ||
                        generalSettings.paypalPublicKey == '' ||
                        generalSettings.paypalSecretKey == ''
                      "
                      :loading="isLoading"
                      @click="confirmUpdateSettings"
                    >
                      Modifier
                    </v-btn>
                  </div>
                </v-col>
              </v-row>
            </v-card-text>
          </v-form>
        </v-card>
      </v-col>
    </v-row>
    <v-snackbar
      :color="snackbar.color"
      v-model="snackbar.visible"
      :top="snackbar.position === 'top'"
    >
      {{ snackbar.text }}
    </v-snackbar>
  </section>
</template>
<script>
import Constant from "@/utils/constants";
import VueUploadMultipleImage from "vue-upload-multiple-image";
import store from "@/store/image";

export default {
  components: { VueUploadMultipleImage },
  data() {
    return {
      isLoading: false,
      images: [],
      snackbar: {
        position: "top",
        timeout: 3000,
        color: null,
        text: "",
        visible: false,
      },
      generalSettings: {
        id: "",
        duaaOption: false,
        premiumGifId: null,
        paypalSecretKey: "",
        paypalPublicKey: "",
        stripePublicKey: "",
        stripeSecretKey: "",
      },
      showlowding: false,
    };
  },

  async created() {
    await this.fetchGeneralSettings();
  },

  methods: {
    async fetchGeneralSettings() {
      try {
        const response = await fetch(
          `${Constant.QORANI}library/generalSetting/get`
        );

        if (response.ok) {
          const data = await response.json();
          console.log(data);

          this.generalSettings = data;
          if (this.generalSettings.premiumGifId != null) {
            console.log();

            this.images.push({
              name: "",
              path: `${Constant.QORANI}fileDB/files/${this.generalSettings.premiumGifId}`,
              highlight: 1,
              default: 1,
            });
          }
        } else {
          throw new Error("Network response was not ok");
        }
      } catch (error) {
        console.error(
          "Erreur lors de la récupération des paramètres généraux :",
          error
        );
      }
    },
    beforeRemove(index, done, fileList) {
      this.showlowding = false;
      this.fakePercentage = 0;
      this.uploadPercentage = 0;
      const r = confirm("remove image");
      if (r === true) {
        const indexInArrayImages = this.images.indexOf(fileList[index].path);
        this.generalSettings.premiumGifId = null;

        if (index > -1) {
          this.images.splice(indexInArrayImages, 1);
        }

        done();
      }
    },
    async uploadImageSuccess(formData, index, fileList) {
      try {
        await store.dispatch("uploadImageSuccess", {
          formData,
          index,
          fileList,
        });
        const imageId = store.state.imageId;
        this.generalSettings.premiumGifId = imageId;
      } catch (error) {
        console.error("Failed to upload image:", error);
      }
    },
    async confirmUpdateSettings() {
      this.isLoading = true;
      if (this.generalSettings.premiumGifId == null) {
        const responseCategorie = await fetch(
          Constant.QORANI + "library/generalSetting/deleteGif/1",
          {
            method: "GEt",
            headers: {
              "Content-Type": "application/json",
            },
          }
        );
      }
      console.log(this.generalSettings.premiumGifId);

      try {
        const responseCategorie = await fetch(
          Constant.QORANI + "library/generalSetting/edit/1",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(this.generalSettings),
          }
        );
        this.snackbar.text =
          "La mise à jour des paramètres généraux a été modifier avec succés ! ";
        this.snackbar.color = "success";
        this.snackbar.visible = true;

        setTimeout(() => {
          this.$router.push({
            path: this.$route.path,
            query: { refresh: Date.now() },
          });
        }, 1000);
      } catch (error) {
        console.error(
          "Erreur lors de la mise à jour des paramètres généraux :",
          error
        );
        this.snackbar.text = "Une erreur est survenue, veuillez réessayer.";
        this.snackbar.color = "error";
        this.snackbar.visible = true;
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>
<style lang="css">
@import "~vue2-editor/dist/vue2-editor.css";

/* Import the Quill styles you want */
@import "~quill/dist/quill.core.css";
@import "~quill/dist/quill.bubble.css";
@import "~quill/dist/quill.snow.css";
</style>
